module.exports = __webpack_public_path__ + "img/galery-msu3-1.dbd40c79.png";